export enum StatusBadgeStatus {
    ToComplete = 'to-complete',
    Complete = 'complete',
    Unknown = 'unknown',
}

export const stateIconMap = {
    [StatusBadgeStatus.ToComplete]: 'https://assets.smooved.be/icons/v2/20/circle-alert-inverted.svg',
    [StatusBadgeStatus.Complete]: 'https://assets.smooved.be/icons/v2/20/check-filled.svg',
    [StatusBadgeStatus.Unknown]: 'https://assets.smooved.be/icons/v2/20/circle-dashed.svg',
};
